import { render, staticRenderFns } from "./DetailSociete.vue?vue&type=template&id=94d2ab4e"
import script from "./DetailSociete.vue?vue&type=script&lang=js"
export * from "./DetailSociete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports